import moment from 'moment'
import 'moment/locale/es'
import {cuentaMask, dineroDisabledMask} from '../Components/Items'

moment.locale('es')

const reporteEstadoDeResultadosPdf = (values) => {
    const empresa = values.empresa

    let filtrados = []

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},

            {text: '', style: 'textoChico'}
      ] )
    }

    let totalIngresos = 0
    let totalEgresos = 0
    let ingresosTable = values.arrayIngresos.map(valueIngresos => {
        if(valueIngresos.nivel === 1){
            totalIngresos += valueIngresos.saldo
        }
        return [
            {text: cuentaMask(valueIngresos.nivel1+valueIngresos.nivel2+valueIngresos.nivel3+valueIngresos.nivel4+valueIngresos.nivel5), style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico', alignment: 'left'}, 
            {text: valueIngresos.descripcion, style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico', alignment: 'left'}, 
            {text: dineroDisabledMask(valueIngresos.saldo), style: valueIngresos.titulo ? 'tituloCuentasMayor' : valueIngresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico', alignment: 'right'},
        ]
    })
    let egresosTable = values.arrayEgresos.map(valueEgresos => {
        if(valueEgresos.nivel === 1){
            totalEgresos += valueEgresos.saldo
        }
        return [
            {text: cuentaMask(valueEgresos.nivel1+valueEgresos.nivel2+valueEgresos.nivel3+valueEgresos.nivel4+valueEgresos.nivel5), style: valueEgresos.titulo ? 'tituloCuentasMayor' : valueEgresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico', alignment: 'left'}, 
            {text: valueEgresos.descripcion, style: valueEgresos.titulo ? 'tituloCuentasMayor' : valueEgresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico', alignment: 'left'}, 
            {text: dineroDisabledMask(valueEgresos.saldo), style: valueEgresos.titulo ? 'tituloCuentasMayor' : valueEgresos.titulo2 ? 'tituloCuentasMenor' : 'textoChico', alignment: 'right'},
        ]
    })




    var dd = {
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: [ '18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
    //							rowSpan: 3,
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80] 
                                //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                            },
                            {
                            //	rowSpan: 2,
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],
                                
                                    body: [
                                      [
                                          { 
                                          text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno), 
                                          style: "tableHeader" 
                                          }
                                      ],
                                      [
                                        {
                                          text: "R.F.C: "+empresa.rfc,
                                          style: "textoChico",
                                          alignment: "center",
                                        },
                                      ],
                                      [
                                          {
                                            text: empresa.calle+' '+
                                                  empresa.numeroCalle+' '+
                                                  (empresa.numeroInterior ? empresa.numeroInterior : '')
                                            ,
                                            style: "textoChico",
                                            alignment: "center",
                                          },
                                        ],
                                      [
                                          {
                                            text: empresa.colonia.tipoAsentamiento+' '+
                                            empresa.colonia.nombre+' C.P. '+
                                            empresa.colonia.cp+' '+
                                            empresa.municipio.nombre+' '+
                                            empresa.estado.abreviatura+' '+
                                            empresa.pais.abreviatura+' '
                                            ,
                                            style: "textoChico",
                                            alignment: "center",
                                          },
                                        ],
                                        [{text: 'ESTADO DE RESULTADOS', style: 'tableHeader'}],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                            values.ocultarDatosFiltrado
                                ? {text: '', border: [false, false, false, false]}
                                : {
                                border: [false, false, false, false],
                                    table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'center'}],
                                        [{text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                        [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                        [{text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                        [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                        [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]
    
                    ]
                },
            },
            ...(values.ocultarDatosFiltrado ? [] : [
            {text: 'Datos de filtrado:'},
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                                        defaultBorder: false,
                                    },

                    body: filtrados,
                },
                            layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return {dash: {length: 2, space: 1}};
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return {dash: {length: 2}};
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }

            },
            ]),
            {
            table: {
                widths: ['20%', '60%', '20%'],
                layout: {
                    defaultBorder: true,
                },
                body: [
                    [
                        {colSpan: 3,text: 'INGRESOS', style: 'tituloTabla1'},
                        {},
                        {}
                    ],
                    [
                        {text: 'Cuenta', style: 'tituloTabla'},
                        {text: 'Descripción', style: 'tituloTabla'},
                        {text: 'Importe', style: 'tituloTabla'},
                    ],
                    ...ingresosTable,
                    [
                        {border: [false,false, false,false], text: 'Suma de los Ingresos', style: 'subheader', colSpan: 2},
                        {border: [false,false, false,false], text: '', style: 'textoChico',},
                        {border: [false,true, false,false], text: dineroDisabledMask(totalIngresos), style: 'textoChico', alignment: 'right'}
                    ],
                    [
                        {colSpan: 3,text: 'EGRESOS', style: 'tituloTabla1'},
                        {},
                        {}
                    ],
                    [
                        {text: 'Cuenta', style: 'tituloTabla'},
                        {text: 'Descripción', style: 'tituloTabla'},
                        {text: 'Importe', style: 'tituloTabla'},
                    ],
                    ...egresosTable,
                    [
                        {border: [false,false, false,false], text: 'Suma de los Egresos', style: 'subheader', colSpan: 2},
                        {border: [false,false, false,false], text: '', style: 'textoChico',},
                        {border: [false,true, false,false], text: dineroDisabledMask(totalEgresos), style: 'textoChico', alignment: 'right'}
                    ]
                ]
            },
            layout: 'noBorders'
            },
            {
                alignment: 'right',
              table: {
                  widths: ['20%', '60%', '20%'],
                  layout: {
                    defaultBorder: false,
                  },
                  body: [
                      [
                        {border: [false,false, false,false], text: 'Utilidad o Perdida:', style: 'subheader', colSpan: 2},
                        {border: [false,false, false,false], text: '', style: 'textoChico',},
                        {border: [false,true, false,false], text: dineroDisabledMask(totalIngresos-totalEgresos), style: 'textoChico', alignment: 'right'}
                      ],
                  ]
              },
            },
        ],
        images: {
            logo: empresa.logo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico:{
                fontSize: 8
            },
            tituloTabla:{
                fontSize: 8,
                bold: true, 
                fillColor: '#cccccc', 
                alignment: 'center',
            },
            tituloTabla1:{
                fontSize: 12,
                bold: true, 
                alignment: 'center',
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            },
            tituloCuentasMayor: {
                fontSize: 8,
                bold: true, 
                fillColor: '#E0E0E0', 
                alignment: 'center',
            },
            tituloCuentasMenor: {
                fontSize: 8,
                bold: true, 
                fillColor: '#F9F9F9', 
                alignment: 'center',
            },
        },
        pageSize: 'LETTER',
    }
  return dd;
};


export default reporteEstadoDeResultadosPdf;
